import React from "react";

// Lightweight, reusable color picker popover used by Set Path Color blocks.
export default function ColorPickerPopover({
  open,
  position = { top: 0, left: 0 },
  value = "#000000",
  onChange,
  onClose,
}) {
  if (!open) return null;

  const presets = ["#000000", "#FF0000", "#00A86B", "#0066FF", "#FFC700", "#FF7A00", "#9B51E0", "#00C2FF"];

  const handlePreset = (hex) => {
    onChange?.(hex);
    onClose?.();
  };

  const clampedLeft = Math.max(12, Math.min(position.left, window.innerWidth - 220));
  const clampedTop = Math.max(12, position.top);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 4000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: "absolute",
          top: clampedTop,
          left: clampedLeft,
          background: "#ffffff",
          borderRadius: "14px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
          width: 200,
          padding: "14px 12px",
          border: "1px solid #ececec",
          zIndex: 4001,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 10,
          }}
        >
          <div
            style={{
              height: 40,
              flex: "0 0 70px",
              borderRadius: 10,
              background: value,
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "inset 0 1px 2px rgba(0,0,0,0.1)",
            }}
          />
          <input
            type="color"
            aria-label="Choose color"
            value={value}
            onChange={(e) => onChange?.(e.target.value.toUpperCase())}
            style={{
              width: 44,
              height: 44,
              border: "1px solid #d9d9d9",
              borderRadius: 8,
              padding: 0,
              cursor: "pointer",
              background: "#f7f7f7",
            }}
          />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8, marginBottom: 10 }}>
          {presets.map((c) => (
            <button
              key={c}
              onClick={() => handlePreset(c)}
              style={{
                height: 24,
                borderRadius: 6,
                border: c.toUpperCase() === value?.toUpperCase()
                  ? "2px solid #4A90E2"
                  : "1px solid #e0e0e0",
                background: c,
                cursor: "pointer",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
              }}
              aria-label={`Preset ${c}`}
            />
          ))}
        </div>

        <input
          type="text"
          value={value}
          onChange={(e) => onChange?.(e.target.value.toUpperCase())}
          maxLength={7}
          style={{
            width: "100%",
            padding: "10px 12px",
            borderRadius: 10,
            border: "1px solid #dcdcdc",
            fontSize: 12,
            letterSpacing: "0.5px",
            textTransform: "uppercase",
            boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)",
            marginBottom: 10,
          }}
          placeholder="#000000"
        />

        <button
          onClick={onClose}
          style={{
            width: "100%",
            padding: "10px 0",
            borderRadius: 10,
            border: "1px solid #dcdcdc",
            background: "#f6f6f6",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Done
        </button>
      </div>
    </div>
  );
}
